import React, { Component, Fragment } from "react";
import EmptyState from "../common/EmptyState";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import {
  getAllDocumentExpressRatesRedux,
  getAllOfficeRedux,
  getAllCnfRedux,
  getAllEmployeeRedux,
  uploadExpenseRedux,
  uploadCashInRedux,
  getAllExpenseRedux,
  getAllPendingExpenseByDayRedux,
  getAllPendingCashInByDayRedux,
  deleteExpenseRedux,
  deleteCashInRedux,
  updateExpenseRedux,
  updateCashInRedux,
  getSingleCashSummaryRedux,
  getSingleMonthlyRedux,
  getAllMonthlyRedux,
} from "../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Clock from "./clock";
import { DollarSign } from "react-feather";
import { CircleLoader } from "react-spinners";
import {
  getMonth,
  createSalaryMonth,
  uploadImage,
  deleteImage,
} from "../../firebase/firebase.utils";
import man from "../../assets/images/plus image.jpeg";
import { notifyWarning } from "../../utils/notify";
import "./daily-expense.css";
export class DailyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: "",
      customerUid: "",
      showSuggestion: true,
      open: false,
      toggleModal: true,
      singleLot: null,
      time: "",
      monthName: "",
      category: "",
      subCategory: "",
      note: "",
      amount: "",
      expenseObj: null,
      cursor: -1,
      loader: false,
      months: [],
      filterCategoryCashIn: "",
      filterCategoryCashOut: "",
      imageUrl: man,
      image_loader: false,
    };
  }

  componentDidMount = async () => {
    let date = new Date();
    console.log("component did mount is getting called!");
    this.props.getSingleCashSummaryRedux();
    console.log(date.toLocaleDateString("en-GB"));
    this.props.getAllPendingExpenseByDayRedux(date.toLocaleDateString("en-GB"));
    this.props.getAllPendingCashInByDayRedux(date.toLocaleDateString("en-GB"));
    this.props.getAllCnfRedux();
    this.props.getAllEmployeeRedux();
    this.props.getAllOfficeRedux();
  };

  componentWillReceiveProps = async (nextProps) => {
    if (this.props.allEmployees.length !== nextProps.allEmployees.length) {
      if (nextProps.allEmployees && nextProps.allEmployees.length > 0) {
        nextProps.allEmployees.map(async (employee) => {
          await createSalaryMonth(this.getMonthName(), employee);
        });
      }
    }
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      {
        [name]: value,
      },
      async () => {
        if (this.state.category === "SALARY" && this.state.subCategory !== "") {
          const months = await getMonth(
            this.state.subCategory,
            this.getMonthName()
          );
          this.props.getAllMonthlyRedux("SALARY", this.state.subCategory);
          this.setState({ months });
        }
      }
    );
  };
  handleMonthChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      {
        [name]: value,
      },
      async () => {
        if (this.state.category === "SALARY" && this.state.subCategory !== "") {
          if (this.state.note !== "") {
            document.getElementById("salary").click();
            this.props.getSingleMonthlyRedux(
              this.state.note,
              "SALARY",
              this.state.subCategory
            );
          }
        }
      }
    );
  };

  handleChangeCustomer = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, showSuggestion: true, cursor: -1 });
  };

  // Some customer records have no userId — building "undefined-Name" is
  // worse than just falling back to the name alone. A handful of legacy
  // records also have the literal string "undefined" saved as their
  // userId (from an upstream bug elsewhere), so that's treated as invalid too.
  hasUserId = (userId) => !!userId && userId !== "undefined";

  buildCustomerSubCategory = (userId, displayName) =>
    this.hasUserId(userId) ? `${userId}-${displayName || ""}` : displayName || "";

  handleKeyDown = (e) => {
    const { cursor } = this.state;
    let result = [];
    if (this.state.customer) {
      const suggestionById = this.props.allUsers.filter(
        (user) =>
          this.hasUserId(user.userId) &&
          user.userId.includes(this.state.customer)
      );
      const suggestionByName = this.props.allUsers.filter(
        (user) =>
          user.displayName &&
          user.displayName
            .toLowerCase()
            .includes(this.state.customer.toLowerCase())
      );
      result = [...suggestionById, ...suggestionByName].slice(0, 10);

      // arrow up/down button should select next/previous list element
      if (e.keyCode === 38 && cursor > -1) {
        this.setState((prevState) => ({
          cursor: prevState.cursor - 1,
        }));
      } else if (e.keyCode === 40 && cursor < result.length - 1) {
        this.setState((prevState) => ({
          cursor: prevState.cursor + 1,
        }));
      } else if (e.keyCode === 13 && cursor > -1) {
        const selected = result[cursor];
        this.setState({
          customer: this.hasUserId(selected.userId)
            ? selected.userId
            : selected.displayName || "",
          customerUid: selected.uid,
          showSuggestion: false,
          subCategory: this.buildCustomerSubCategory(
            selected.userId,
            selected.displayName
          ),
        });
      }
    } else {
      result = [];
    }
  };

  renderShowSuggestion = () => {
    let suggestionArray = [];
    console.log(this.state.customer);
    if (this.state.customer) {
      const suggestionById = this.props.allUsers.filter(
        (user) =>
          this.hasUserId(user.userId) &&
          user.userId.includes(this.state.customer)
      );
      const suggestionByName = this.props.allUsers.filter(
        (user) =>
          user.displayName &&
          user.displayName
            .toLowerCase()
            .includes(this.state.customer.toLowerCase())
      );
      suggestionArray = [...suggestionById, ...suggestionByName];
      const uniqueUser = [...new Set(suggestionArray)];
      return uniqueUser.slice(0, 10).map((user, index) => (
        <li
          key={user.uid || user.userId || index}
          className={`de-suggest-item${this.state.cursor == index ? " de-suggest-item--active" : ""}`}
          onClick={() =>
            this.setState({
              customer: this.hasUserId(user.userId)
                ? user.userId
                : user.displayName || "",
              customerUid: user.uid,
              showSuggestion: false,
              subCategory: this.buildCustomerSubCategory(user.userId, user.displayName),
            })
          }
        >
          {this.hasUserId(user.userId) ? `${user.userId}-` : ""}
          {user.displayName ? user.displayName.slice(0, 13) : ""}
        </li>
      ));
    }
  };

  renderSubCategory = () => {
    const { category } = this.state;
    const { allOffices, allCnfs, allEmployees } = this.props;
    if (
      category === "DAILY COST" ||
      category === "REFUND" ||
      category === "TRANSPORT"
    ) {
      return (
        <div className="col de-field">
          <label className="de-label">{category}</label>
          <select
            title="Please choose a package"
            required
            name="subCategory"
            className="custom-select de-select"
            aria-required="true"
            aria-invalid="false"
          >
            <option value={category}>{category}</option>
          </select>
        </div>
      );
    } else if (category === "OFFICE") {
      return (
        <div className="col de-field">
          <label className="de-label">Office</label>
          <select
            title="Please choose a package"
            required
            name="subCategory"
            value={this.state.subCategory}
            onChange={this.handleChange}
            className="custom-select de-select"
            aria-required="true"
            aria-invalid="false"
          >
            <option value="">Select office</option>
            {allOffices.map((office) => (
              <option value={office.name}>{office.name}</option>
            ))}
          </select>
        </div>
      );
    } else if (
      category === "SALARY" ||
      category === "SOURCING" ||
      category === "PURCHASING"
    ) {
      return (
        <div className="col de-field">
          <label className="de-label">{category}</label>
          <select
            title="Please choose a package"
            required
            name="subCategory"
            className="custom-select de-select"
            aria-required="true"
            aria-invalid="false"
            onChange={this.handleChange}
            value={this.state.subCategory}
          >
            <option value="">Select employee</option>
            {allEmployees.map((employee, index) => (
              <option value={`${employee.name}`} key={index}>
                {employee.name}-{employee.designation}
              </option>
            ))}
          </select>
        </div>
      );
    } else if (category === "LOAN") {
      return (
        <div className="col de-field">
          <label className="de-label">{category}</label>
          <input
            title="Please choose a package"
            type="text"
            name="customer"
            className="form-control de-input"
            placeholder="Enter customer Id"
            aria-required="true"
            aria-invalid="false"
            onChange={this.handleChangeCustomer}
            value={this.state.customer}
            required
            autoComplete="off"
            onKeyDown={this.handleKeyDown}
          />
          {this.state.customer && (
            <ul
              className="de-suggest-list"
              style={{
                display: this.state.showSuggestion ? "block" : "none",
              }}
            >
              {this.renderShowSuggestion()}
            </ul>
          )}
        </div>
      );
    } else if (category === "OTHERS") {
      return (
        <div className="col de-field">
          <label className="de-label">
            Sub category
          </label>

          <input
            type="text"
            name="subCategory"
            className="form-control de-input"
            placeholder="Enter sub category"
            onChange={this.handleChange}
            value={this.state.subCategory}
            required
          />
        </div>
      );
    } else if (category === "Boosting") {
      return (
        <div className="col de-field">
          <label className="de-label">
            Sub category
          </label>

          <input
            type="text"
            name="subCategory"
            className="form-control de-input"
            placeholder="Enter sub category"
            onChange={this.handleChange}
            value={this.state.subCategory}
            required
          />
        </div>
      );
    } else if (category === "BUY PRODUCTS") {
      return (
        <div className="col de-field">
          <label className="de-label">
            Sub category
          </label>

          <input
            type="text"
            name="subCategory"
            className="form-control de-input"
            placeholder="Enter product name"
            onChange={this.handleChange}
            value={this.state.subCategory}
            required
          />
        </div>
      );
    } else if (category === "SHIPPING") {
      return (
        <div className="col de-field">
          <label className="de-label">
            Sub category
          </label>

          <input
            type="text"
            name="subCategory"
            className="form-control de-input"
            placeholder="Enter LOT number"
            onChange={this.handleChange}
            value={this.state.subCategory}
            required
          />
        </div>
      );
    } else if (category === "INVEST") {
      return (
        <div className="col de-field">
          <label className="de-label">Select investment source</label>
          <select
            title="Please choose a package"
            required
            name="subCategory"
            className="custom-select de-select"
            aria-required="true"
            aria-invalid="false"
            onChange={this.handleChange}
            value={this.state.subCategory}
          >
            <option value="">Select employee</option>
            {allEmployees.map((employee, index) => (
              <option value={`${employee.name}`} key={index}>
                {employee.name}-{employee.designation}
              </option>
            ))}
          </select>
        </div>
      );
    }
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmitCashOut = async (e) => {
    e.preventDefault();

    let remainingSalary = 0;

    let selectedMonths = this.state.months.find(
      (month) => month.month == this.state.note
    );
    if (selectedMonths) {
      remainingSalary =
        parseInt(selectedMonths.salary) - parseInt(selectedMonths.amount);
    }
    if (this.state.loader) {
      return;
    }
    if (
      this.state.category === "SALARY" &&
      this.state.amount > remainingSalary
    ) {
      notifyWarning(`Paid Amount can't be greater than ${remainingSalary}`);
      return;
    }
    this.setState({ loader: true });
    const { currentAdmin } = this.props;
    let date = new Date();
    let subCategory = this.state.subCategory;
    if (this.state.category === "LOAN" && this.state.customerUid === "") {
      notifyWarning("Please select a customer first");
      return;
    }
    if (this.state.category === "DAILY COST") {
      subCategory = "DAILY OFFICE COST";
    } else if (this.state.category === "FUND") {
      subCategory = "OFFICE FUND";
    } else if (this.state.category === "REFUND") {
      subCategory = "REFUND PURPOSE";
    } else if (this.state.category === "AGENT COMMISION") {
      subCategory = "COMMISION PURPOSE";
    } else if (this.state.category === "TRANSPORT") {
      subCategory = "TRANSPORT";
    }

    if (this.state.file) {
      const reader = new FileReader();
      reader.readAsDataURL(this.state.file);
      const imgUrl = await uploadImage(this.state.file, "cashouts");
      console.log(imgUrl);

      this.setState({
        imageUrl: imgUrl,
      });

      console.log(imgUrl);
      let expenseObj = {
        id: date.getTime().toString(),
        category: this.state.category,
        subCategory,
        month:
          this.state.category === "SALARY"
            ? this.state.note
            : this.getMonthName(),
        date: date.toLocaleDateString("en-GB"),
        note: this.state.note,
        amount: this.state.amount,
        expenseBy: currentAdmin.name,
        status: "pending",
        uid: this.state.customerUid,
        imageUrl: imgUrl,
      };

      await this.props.uploadExpenseRedux(expenseObj);
    } else {
      let expenseObj = {
        id: date.getTime().toString(),
        category: this.state.category,
        subCategory,
        month:
          this.state.category === "SALARY"
            ? this.state.note
            : this.getMonthName(),
        date: date.toLocaleDateString("en-GB"),
        note: this.state.note,
        amount: this.state.amount,
        expenseBy: currentAdmin.name,
        status: "pending",
        uid: this.state.customerUid,
        imageUrl: this.state.imageUrl,
      };

      await this.props.uploadExpenseRedux(expenseObj);
    }

    this.setState({
      time: "",
      category: "",
      subCategory: "",
      note: "",
      amount: "",
      customer: "",
      customerUid: "",
      loader: false,
    });
  };
  handleSubmitCashIn = async (e) => {
    e.preventDefault();
    if (this.state.loader) {
      return;
    }
    this.setState({
      loader: true,
    });
    const { currentAdmin } = this.props;
    let date = new Date();
    let subCategory = this.state.subCategory;
    if (this.state.category === "LOAN" && this.state.customerUid === "") {
      notifyWarning("Please select a customer first");
      return;
    }

    if (this.state.category === "FUND") {
      subCategory = "OFFICE FUND";
    }

    if (!subCategory) {
      notifyWarning("please choose a subcategory.");
      return;
    }
    let cashInObj = {
      id: date.getTime().toString(),
      category: this.state.category,
      subCategory,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: this.state.note,
      amount: this.state.amount,
      receiveBy: currentAdmin.name,
      status: "pending",
      uid: this.state.customerUid,
    };

    await this.props.uploadCashInRedux(cashInObj);
    this.setState({
      time: "",
      category: "",
      subCategory: "",
      note: "",
      amount: "",
      customer: "",
      customerUid: "",
      loader: false,
    });
  };

  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
    this.setState({
      category: "",
      subCategory: "",
      note: "",
      amount: "",
    });
  };

  _handleImgChange = (e, i) => {
    e.preventDefault();

    const fileInput = e.target; // 🧠 store a reference before async code
    const file = fileInput.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        file: file,
        imageUrl: reader.result, // base64 preview
      });

      // 🛠️ Reset input safely
      if (fileInput) fileInput.value = "";
    };

    reader.onerror = (err) => {
      console.error("File reading error:", err);
    };

    reader.readAsDataURL(file);
  };

  renderMonths = () => {
    const { months } = this.state;
    console.log(months);

    return (
      <select
        title="Please choose a package"
        required
        name="note"
        className="custom-select de-select"
        aria-required="true"
        aria-invalid="false"
        onChange={this.handleMonthChange}
        value={this.state.note}
        aria-disabled
      >
        {(months.length > 0) & (this.state.subCategory !== "") ? (
          <>
            <option value="">Select a month</option>
            {months.map((month) => (
              <option value={month.month}>{month.month}</option>
            ))}
          </>
        ) : this.state.subCategory == "" ? (
          <option value="" disabled>
            Select an employee first
          </option>
        ) : (
          <option value="" disabled>
            PLEASE CREATE A MONTH FIRST- (upto date salary is given)
          </option>
        )}
      </select>
    );
  };

  render() {
    const { open, expenseObj, allMonths } = this.state;
    const {
      expenses,
      allOffices,
      allCnfs,
      allEmployees,
      cashIns,
      todaysCash,
      allExpenses,
    } = this.props;
    let date = new Date();
    let total = 0;
    let totalCashIns = 0;

    let remainingSalary = 0;

    let renderableExpense = expenses;
    if (this.state.filterCategoryCashOut) {
      renderableExpense = expenses.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashOut.toLowerCase()
      );
    }
    renderableExpense.map((expense) => (total += parseInt(expense.amount)));

    let renderableCashIn = cashIns;
    if (this.state.filterCategoryCashIn) {
      renderableCashIn = cashIns.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashIn.toLowerCase()
      );
    }
    renderableCashIn.map(
      (expense) => (totalCashIns += parseInt(expense.amount))
    );

    // Unfiltered (category filter shouldn't affect the top summary pills)
    // totals of today's still-pending entries, so the "Today's Cash In/Out"
    // pills reflect what's on this page immediately, not just what's
    // already been approved via the separate Approve Expense page.
    let pendingCashOutTotal = 0;
    expenses.forEach((expense) => {
      pendingCashOutTotal += parseInt(expense.amount) || 0;
    });
    let pendingCashInTotal = 0;
    cashIns.forEach((cashIn) => {
      pendingCashInTotal += parseInt(cashIn.amount) || 0;
    });
    const todaysCashInDisplay =
      (parseInt(todaysCash && todaysCash.totalCashIns) || 0) + pendingCashInTotal;
    const todaysCashOutDisplay =
      (parseInt(todaysCash && todaysCash.totalCashOuts) || 0) + pendingCashOutTotal;

    console.log(this.props);
    let selectedMonths = this.state.months.find(
      (month) => month.month == this.state.note
    );
    console.log(selectedMonths);
    if (selectedMonths) {
      remainingSalary =
        parseInt(selectedMonths.salary) - parseInt(selectedMonths.amount);
    }
    return (
      <Fragment>
        <Breadcrumb title={date.toDateString()} parent="Cash" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid de-page kd-cash kd-st--sky">
          <div className="row de-stats-row">
            <div className="col-xl-3 col-md-6 xl-50">
              <div className="de-stat-card">
                <div className="de-stat-icon de-stat-icon--warning">
                  <DollarSign />
                </div>
                <div>
                  <div className="de-stat-eyebrow de-stamp-font">Remaining Cash</div>
                  <div className="de-stat-value">
                    <CountUp
                      className="counter"
                      end={todaysCash && todaysCash.remainingBalance}
                    />
                    Tk
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 xl-50">
              <div className="de-stat-card">
                <div className="de-stat-icon de-stat-icon--success">
                  <DollarSign />
                </div>
                <div>
                  <div className="de-stat-eyebrow de-stamp-font">Todays Cash In</div>
                  <div className="de-stat-value">
                    <CountUp
                      className="counter"
                      end={todaysCashInDisplay}
                    />
                    Tk
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 xl-50">
              <div className="de-stat-card">
                <div className="de-stat-icon de-stat-icon--danger">
                  <DollarSign />
                </div>
                <div>
                  <div className="de-stat-eyebrow de-stamp-font">Todays Cash Out</div>
                  <div className="de-stat-value">
                    <CountUp
                      className="counter"
                      end={todaysCashOutDisplay}
                    />
                    Tk
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 xl-50">
              <div className="de-stat-card">
                <div className="de-stat-icon de-stat-icon--neutral">
                  <DollarSign />
                </div>
                <div>
                  <div className="de-stat-eyebrow de-stamp-font">Previous Cash</div>
                  <div className="de-stat-value">
                    <CountUp
                      className="counter"
                      end={todaysCash && todaysCash.previousCash}
                    />
                    Tk
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <Tabs>
              <TabList
                className="nav nav-tabs tab-coupon de-tablist"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Tab
                  className="nav-link de-tab"
                  onClick={(e) => this.clickActive(e)}
                >
                  Cash Out
                </Tab>

                <Tab
                  className="nav-link de-tab"
                  onClick={(e) => this.clickActive(e)}
                >
                  Cash In
                </Tab>
              </TabList>
              <TabPanel>
                <div className="col-sm-12">
                  <div className="card de-card">
                    <div className="card-header de-card-header">
                      <h5 className="de-card-title">
                        <i className="icofont-bill de-card-icon"></i>
                        Cash Out
                      </h5>
                      <Clock />
                    </div>
                    <div className="card-body">
                      <div className="clearfix"></div>
                      <div>
                        <div id="basicScenario" className="product-physical">
                          <form
                            className="de-form"
                            onSubmit={this.handleSubmitCashOut}
                          >
                            <div className="form-row mb-2">
                              <div className="col de-field">
                                <label className="de-label">
                                  Category
                                </label>
                                <select
                                  title="Please choose a package"
                                  required
                                  name="category"
                                  className="custom-select de-select"
                                  aria-required="true"
                                  aria-invalid="false"
                                  onChange={this.handleChange}
                                  value={this.state.category}
                                >
                                  <option value="">Select category </option>
                                  <option value="DAILY COST">Daily cost</option>
                                  <option value="OFFICE">Office</option>
                                  <option value="SALARY">Salary</option>
                                  <option value="LOAN">Loan</option>
                                  <option value="SHIPPING">Shipping</option>
                                  <option value="Boosting">
                                    Boosting/promotion
                                  </option>
                                  <option value="REFUND">Refund</option>
                                  <option value="TRANSPORT">Transport</option>
                                  <option value="BUY PRODUCTS">
                                    Buy products
                                  </option>
                                </select>
                              </div>
                              {!this.state.category ? (
                                <div className="col de-field">
                                  <label className="de-label de-label--disabled">
                                    {" "}
                                    Sub category
                                  </label>

                                  <select
                                    title="Please choose a package"
                                    required
                                    name="selectCountry"
                                    className="custom-select de-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={this.handleChange}
                                    value={this.state.selectCountry}
                                    aria-disabled
                                    disabled
                                  >
                                    <option value="">
                                      ***choose catgegory first
                                    </option>
                                  </select>
                                </div>
                              ) : (
                                this.renderSubCategory()
                              )}
                              {this.state.category === "SALARY" ? (
                                <div className="col de-field">
                                  <label className="de-label">
                                    Select month
                                  </label>
                                  {this.renderMonths()}
                                </div>
                              ) : null}

                              {this.state.category !== "SALARY" && (
                                <div className="col de-field">
                                  <label className="de-label">
                                    Note
                                  </label>
                                  <input
                                    type="text"
                                    name="note"
                                    className="form-control de-input"
                                    placeholder="Enter additional note"
                                    onChange={this.handleChange}
                                    value={this.state.note}
                                    required
                                  />
                                </div>
                              )}
                            </div>
                            <div
                              className="form-row mb-2"
                              style={{ marginTop: 20 }}
                            >
                              {" "}
                              <div className="col de-field">
                                <label className="de-label">
                                  Amount
                                </label>
                                <input
                                  type="text"
                                  name="amount"
                                  className="form-control de-input"
                                  placeholder="Enter amount"
                                  onChange={this.handleChange}
                                  value={this.state.amount}
                                  required
                                />
                              </div>
                            </div>

                            {this.state.category === "BUY PRODUCTS" ||
                            this.state.category == "SHIPPING" ? (
                              <div
                                className="form-row mb-2"
                                style={{ marginTop: 20 }}
                              >
                                {" "}
                                <div className="col de-field">
                                  <label className="de-label">
                                    UPLOAD IMAGE (payment receipt)
                                  </label>
                                  <div className="form-row mb-4">
                                    <div
                                      className="box-input-file"
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <div className="de-upload-tile">
                                        <img
                                          src={this.state.imageUrl}
                                          alt="#"
                                          onClick={() => {
                                            document
                                              .getElementById(
                                                "upload-image-input"
                                              )
                                              .click();
                                          }}
                                        />
                                        <input
                                          id="upload-image-input"
                                          className="upload"
                                          type="file"
                                          onChange={(e) =>
                                            this._handleImgChange(e, 0)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div></div>
                            )}
                            <div
                              className="form-row de-submit-row"
                            >
                              <button
                                className="btn de-submit-btn"
                                type="submit"
                              >
                                {!this.state.loader && "Save entry"}
                                <CircleLoader
                                  loading={this.state.loader}
                                  color="white"
                                  size={15}
                                />
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card de-card">
                    <div className="card-header de-card-header">
                      <h5 className="de-card-title">
                        <i className="icofont-money de-card-icon"></i>
                        Today's Pending Cash Out
                      </h5>
                      <div>
                        <select
                          title="Filter by category"
                          required
                          name="filterCategoryCashOut"
                          className="custom-select de-select de-select--compact"
                          aria-required="true"
                          aria-invalid="false"
                          onChange={this.handleChange}
                          value={this.state.filterCategoryCashOut}
                        >
                          <option value="">Filter by category </option>
                          <option value="">All</option>
                          <option value="DAILY COST">Daily cost</option>
                          <option value="OFFICE">Office</option>
                          <option value="SALARY">Salary</option>
                          <option value="LOAN">Loan</option>
                          <option value="SHIPPING">Shipping</option>
                          <option value="Boosting">Boosting/promotion</option>
                          <option value="REFUND">Refund</option>
                          <option value="TRANSPORT">Transport</option>
                          <option value="BUY PRODUCTS">Buy products</option>
                        </select>
                      </div>
                    </div>
                    <div className="card-body de-table-wrap">
                      <div className="clearfix"></div>
                      <div id="basicScenario" className="product-physical">
                        <table className="table table-hover de-table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Category</th>
                              <th scope="col">Sub Category</th>
                              <th scope="col">Note</th>
                              <th scope="col">Amount</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {renderableExpense.length === 0 && (
                              <tr>
                                <td colSpan={6} className="de-empty">
                                  <EmptyState>No cash out entries yet today.</EmptyState>
                                </td>
                              </tr>
                            )}
                            {renderableExpense.map((expense, index) => (
                              <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>
                                  <span className="de-badge de-badge--danger">{expense.category}</span>
                                  <br />
                                  {expense.imageUrl &&
                                    expense.imageUrl !==
                                      "/static/media/plus image.3dff302b.jpeg" && (
                                      <a
                                        href={expense.imageUrl}
                                        target="_blank"
                                      >
                                        <img
                                          src={expense.imageUrl}
                                          className="de-thumb"
                                        />
                                      </a>
                                    )}
                                </td>
                                <td>{String(expense.subCategory || "").replace(/^undefined-/, "")}</td>
                                <td>{expense.note}</td>
                                <td>{expense.amount}Tk</td>
                                <td>
                                  {(!expense.unEditable ||
                                    process.env.NODE_ENV === "development") && (
                                    <div
                                      className="row"
                                      style={{ justifyContent: "center" }}
                                    >
                                      {!expense.unEditable && (
                                        <button
                                          type="button"
                                          className="de-icon-btn de-icon-btn--edit"
                                          data-toggle="modal"
                                          data-target="#personalInfoModal"
                                          onClick={() => {
                                            this.setState({
                                              expenseObj: expense,
                                              type: "expense",
                                            });
                                          }}
                                        >
                                          <i className="icofont-edit" />
                                        </button>
                                      )}
                                      <button
                                        type="button"
                                        className="de-icon-btn de-icon-btn--delete"
                                        data-toggle="modal"
                                        data-target="#deleteExpenseModal"
                                        onClick={() => {
                                          this.setState({
                                            expenseObj: expense,
                                            type: "expense",
                                          });
                                        }}
                                      >
                                        <i className="icofont-trash" />
                                      </button>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))}
                            <tr className="de-total-row">
                              <td colSpan={3}></td>
                              <td>
                                Total
                              </td>
                              <td colSpan={2}>
                                {total}Tk
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="col-sm-12">
                  <div className="card de-card">
                    <div className="card-header de-card-header">
                      <h5 className="de-card-title">
                        <i className="icofont-bill de-card-icon de-card-icon--success"></i>
                        Cash In
                      </h5>
                      <Clock />
                    </div>
                    <div className="card-body">
                      <div className="clearfix"></div>
                      <div>
                        <div id="basicScenario" className="product-physical">
                          <form
                            className="de-form"
                            onSubmit={this.handleSubmitCashIn}
                          >
                            <div className="form-row mb-2">
                              <div className="col de-field">
                                <label className="de-label">
                                  Category
                                </label>
                                <select
                                  title="Please choose a package"
                                  required
                                  name="category"
                                  className="custom-select de-select"
                                  aria-required="true"
                                  aria-invalid="false"
                                  onChange={this.handleChange}
                                  value={this.state.category}
                                >
                                  <option value="">Select category </option>
                                  <option value="LOAN">Loan</option>
                                  <option value="INVEST">Invest</option>
                                  <option value="OTHERS">Others</option>
                                </select>
                              </div>

                              {!this.state.category ? (
                                <div className="col de-field">
                                  <label className="de-label de-label--disabled">
                                    {" "}
                                    Sub category
                                  </label>

                                  <select
                                    title="Please choose a package"
                                    required
                                    name="selectCountry"
                                    className="custom-select de-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={this.handleChange}
                                    value={this.state.selectCountry}
                                    aria-disabled
                                    disabled
                                  >
                                    <option value="">
                                      ***choose catgegory first
                                    </option>
                                  </select>
                                </div>
                              ) : (
                                this.renderSubCategory()
                              )}

                              <div className="col de-field">
                                <label className="de-label">Note</label>
                                <input
                                  type="text"
                                  name="note"
                                  className="form-control de-input"
                                  placeholder="Enter additional note"
                                  onChange={this.handleChange}
                                  value={this.state.note}
                                  required
                                />
                              </div>
                            </div>
                            <div
                              className="form-row mb-2"
                              style={{ marginTop: 20 }}
                            >
                              {" "}
                              <div className="col de-field">
                                <label className="de-label">
                                  Amount
                                </label>
                                <input
                                  type="text"
                                  name="amount"
                                  className="form-control de-input"
                                  placeholder="Enter amount"
                                  onChange={this.handleChange}
                                  value={this.state.amount}
                                  required
                                />
                              </div>
                            </div>
                            <div className="form-row de-submit-row">
                              <button
                                className="btn de-submit-btn"
                                type="submit"
                              >
                                {!this.state.loader && "Save entry"}
                                <CircleLoader
                                  loading={this.state.loader}
                                  color="white"
                                  size={15}
                                />
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card de-card">
                    <div className="card-header de-card-header">
                      <h5 className="de-card-title">
                        <i className="icofont-money de-card-icon de-card-icon--success"></i>
                        Today's Pending Cash In
                      </h5>
                      <div>
                        <select
                          title="Filter by category"
                          required
                          name="filterCategoryCashIn"
                          className="custom-select de-select de-select--compact"
                          aria-required="true"
                          aria-invalid="false"
                          onChange={this.handleChange}
                          value={this.state.filterCategoryCashIn}
                        >
                          <option value="">Filter by category </option>
                          <option value="">All </option>
                          <option value="LOAN">Loan</option>
                          <option value="OTHERS">Others</option>
                          <option value="ORDERS">Orders</option>
                        </select>
                      </div>
                    </div>
                    <div className="card-body de-table-wrap">
                      <div className="clearfix"></div>
                      <div id="basicScenario" className="product-physical">
                        <table className="table table-hover de-table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Category</th>
                              <th scope="col">Sub Category</th>
                              <th scope="col">Note</th>
                              <th scope="col">Amount</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {renderableCashIn.length === 0 && (
                              <tr>
                                <td colSpan={6} className="de-empty">
                                  <EmptyState>No cash in entries yet today.</EmptyState>
                                </td>
                              </tr>
                            )}
                            {renderableCashIn.map((expense, index) => (
                              <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td><span className="de-badge de-badge--success">{expense.category}</span></td>
                                <td>
                                  {expense.subCategory === "InStock" ? (
                                    <span className="de-badge de-badge--instock">InStock</span>
                                  ) : expense.subCategory === "PreOrder" ? (
                                    <span className="de-badge de-badge--preorder">PreOrder</span>
                                  ) : (
                                    String(expense.subCategory || "").replace(/^undefined-/, "")
                                  )}
                                </td>
                                <td>{expense.note}</td>
                                <td>{expense.amount}Tk</td>
                                <td>
                                  {(!expense.unEditable ||
                                    process.env.NODE_ENV === "development") && (
                                    <div
                                      className="row"
                                      style={{ justifyContent: "center" }}
                                    >
                                      {!expense.unEditable && (
                                        <button
                                          type="button"
                                          className="de-icon-btn de-icon-btn--edit"
                                          data-toggle="modal"
                                          data-target="#personalInfoModal"
                                          onClick={() => {
                                            this.setState({
                                              expenseObj: expense,
                                              type: "cashIn",
                                            });
                                          }}
                                        >
                                          <i className="icofont-edit" />
                                        </button>
                                      )}
                                      <button
                                        type="button"
                                        className="de-icon-btn de-icon-btn--delete"
                                        data-toggle="modal"
                                        data-target="#deleteExpenseModal"
                                        onClick={() => {
                                          this.setState({
                                            expenseObj: expense,
                                            type: "cashIn",
                                          });
                                        }}
                                      >
                                        <i className="icofont-trash" />
                                      </button>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))}
                            <tr className="de-total-row">
                              <td colSpan={3}></td>
                              <td>
                                Total
                              </td>
                              <td colSpan={2}>
                                {totalCashIns}Tk
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
        <div
          className="modal fade de-page de-modal tb-modal kd-cash"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content">
              <div className="modal-header de-modal-header">
                <div className="de-modal-stamp de-stamp-font">Edit entry</div>
                <div className="de-modal-icon-chip">
                  <i className="icofont-edit" />
                </div>
                <div className="modal-title de-modal-title" id="exampleModalLabel">
                  Update Expense
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body de-modal-body">
                <div className="form-group">
                  <label>
                    Category
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="note"
                    value={expenseObj ? expenseObj.category : ""}
                    id="exampleFormControlInput1"
                    placeholder="Enter Additional Note"
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>
                    Sub category
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="note"
                    value={expenseObj ? String(expenseObj.subCategory || "").replace(/^undefined-/, "") : ""}
                    id="exampleFormControlInput1"
                    placeholder="Enter Additional Note"
                    readOnly
                  />
                </div>

                <div className="form-group">
                  <label>
                    Note
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="note"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      this.setState({
                        expenseObj: { ...this.state.expenseObj, note: value },
                      });
                    }}
                    value={expenseObj ? expenseObj.note : ""}
                    id="exampleFormControlInput1"
                    placeholder="Enter Additional Note"
                  />
                </div>
                <div className="form-group">
                  <label>
                    Amount
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="amount"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      this.setState({
                        expenseObj: {
                          ...this.state.expenseObj,
                          amount: value,
                        },
                      });
                    }}
                    value={expenseObj ? expenseObj.amount : ""}
                    id="exampleFormControlInput1"
                    placeholder="Enter Amount"
                  />
                </div>
              </div>
              <div className="modal-footer de-modal-footer">
                <button
                  type="button"
                  className="de-btn de-btn--ghost"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="de-btn de-btn--primary"
                  data-dismiss="modal"
                  onClick={() => {
                    if (this.state.type === "expense") {
                      this.props.updateExpenseRedux(expenseObj);
                    } else {
                      this.props.updateCashInRedux(expenseObj);
                    }
                  }}
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade de-page de-modal tb-modal kd-cash"
          id="deleteExpenseModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content">
              <div className="modal-header de-modal-header">
                <div className="de-modal-stamp de-modal-stamp--danger de-stamp-font">Delete entry</div>
                <div className="de-modal-icon-chip de-modal-icon-chip--danger">
                  <i className="icofont-trash" />
                </div>
                <div className="modal-title de-modal-title" id="exampleModalLabel">
                  Delete Expense
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body de-modal-body">
                <div style={{ marginBottom: 14 }}>Are you sure you want to delete this Expense?</div>
                <table className="table de-table">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {expenseObj && expenseObj.category} <br />{" "}
                        {expenseObj &&
                          expenseObj.imageUrl &&
                          expenseObj.imageUrl !==
                            "/static/media/plus image.3dff302b.jpeg" && (
                            <a href={expenseObj.imageUrl} target="_blank">
                              <img
                                src={expenseObj.imageUrl}
                                className="de-thumb"
                              />
                            </a>
                          )}{" "}
                      </td>
                      <td>{expenseObj && String(expenseObj.subCategory || "").replace(/^undefined-/, "")}</td>
                      <td>{expenseObj && expenseObj.note}</td>
                      <td>{expenseObj && expenseObj.amount}Tk</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer de-modal-footer">
                <button
                  type="button"
                  className="de-btn de-btn--ghost"
                  data-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="de-btn de-btn--danger"
                  data-dismiss="modal"
                  onClick={() => {
                    if (this.state.type === "expense") {
                      this.props.deleteExpenseRedux(expenseObj.id);
                      if (
                        expenseObj &&
                        expenseObj.imageUrl &&
                        expenseObj.imageUrl !==
                          "/static/media/plus image.3dff302b.jpeg"
                      ) {
                        deleteImage(expenseObj.imageUrl);
                      }
                    } else {
                      this.props.deleteCashInRedux(expenseObj.id);
                    }
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade de-page de-modal tb-modal kd-cash"
          id="salaryModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content">
              <div className="modal-header de-modal-header">
                <div className="de-modal-stamp de-stamp-font">Salary ledger</div>
                <div className="de-modal-icon-chip">
                  <DollarSign size={18} />
                </div>
                <div className="modal-title de-modal-title" id="exampleModalLabel">
                  {this.state.note} Salary Details
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body de-modal-body">
                <div className="de-salary-summary-row">
                  <div className="de-salary-summary-box">
                    <div className="de-salary-summary-label de-stamp-font">
                      {this.state.note} Salary
                    </div>
                    <div className="de-salary-summary-value">
                      {selectedMonths ? selectedMonths.salary : 0} Tk
                    </div>
                  </div>
                  <div className="de-salary-summary-box de-salary-summary-box--accent">
                    <div className="de-salary-summary-label de-stamp-font">
                      Remaining
                    </div>
                    <div className="de-salary-summary-value">
                      {remainingSalary} Tk
                    </div>
                  </div>
                </div>

                {allExpenses.length > 0 ? (
                  <table className="table de-table">
                    <thead>
                      <tr>
                        <th scope="col">Note</th>
                        <th scope="col">Date</th>
                        <th scope="col">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allExpenses.map((expense, i) => (
                        <tr key={i}>
                          <td>{expense.note}</td>
                          <td>{expense.date}</td>
                          <td>{expense.amount} Tk </td>
                        </tr>
                      ))}
                      <tr className="de-total-row">
                        <td></td>
                        <td>Total </td>
                        <td>
                          {selectedMonths ? selectedMonths.amount : 0} Tk
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <div className="de-empty-note">
                    No payments recorded for this month yet.
                  </div>
                )}
              </div>
              <div className="modal-footer de-modal-footer">
                <button
                  type="button"
                  className="de-btn de-btn--ghost"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="salary" data-toggle="modal" data-target="#salaryModal"></div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpressDocumentsRates: state.expressRatesDocuments.expressRatesDocuments,
    allOffices: state.offices.offices,
    allCnfs: state.cnfs.cnfs,
    allEmployees: state.employees.employees.filter(
      (employee) => employee.status == "Active"
    ),
    currentAdmin: state.admins.currentAdmin,
    expenses: state.expenses.expenses,
    cashIns: state.cashIns.cashIns,
    todaysCash: state.expenses.todaysCash,
    allUsers: state.users.users,
    allExpenses: state.expenses.singleMonth,
    allMonths: state.expenses.monthly,
  };
};

export default connect(mapStateToProps, {
  getAllDocumentExpressRatesRedux,
  getAllOfficeRedux,
  getAllCnfRedux,
  getAllEmployeeRedux,
  uploadExpenseRedux,
  uploadCashInRedux,
  deleteExpenseRedux,
  deleteCashInRedux,
  updateExpenseRedux,
  updateCashInRedux,
  getAllPendingExpenseByDayRedux,
  getAllPendingCashInByDayRedux,
  getSingleCashSummaryRedux,
  getSingleMonthlyRedux,
  getAllMonthlyRedux,
})(DailyExpense);
